import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

async function render() {
  await import('@/lib/i18n');
  const [{ initSentry }, { initAnalytics }, { default: App }] = await Promise.all([
    import('@/lib/sentry'),
    import('@/lib/analytics'),
    import('./App'),
  ]);
  initSentry();
  initAnalytics();
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

void render();
